// import $ from "jquery";
// import "slick-carousel";
import 'bootstrap/js/dist/tab';
import 'bootstrap/js/dist/collapse';
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import chartD from './chart-d';

class sliderSwiperStories {
  constructor() {
    this.events();
    this.customSelect();
    this.sliderInit();
    this.reportFilter();
    new chartD();
    //this.scrollToForm();
    //this.sliderInit(item.value);
    //this.paginationClass = $('.slider-01-control .slider__pagination');
    //this.paginationClass = $('.slider-02-control .slider__pagination');
  }

  scrollToForm() {
    $(document).on('click', '.text-header-b-content a', (e) => {
      e.preventDefault();
      var myhash = $('.scrollto').attr('href');
      //$(this).addClass('search-tag-is-active');
      //var _topHeight = $('#site-header').height()+$(".search-result-new-header-wrap").height();
      $('html, body').animate(
        {
          scrollTop: $(myhash).offset().top - 72,
        },
        200,
        function () {
          // Add hash (#) to URL when done scrolling (default click behavior)
          //window.location.hash = myhash;
        },
      );
    });
  }

  addClassifactive(selItem) {
    document
      .querySelector('.m-nested-tab')
      .classList.remove('has-m-two-column-bullet-text');
    if (selItem.querySelector('.m-two-column-bullet-text') !== null) {
      selItem
        .closest('.m-nested-tab')
        .classList.add('has-m-two-column-bullet-text');
      // console.log('✅ element has child with id of child-3');
    } else {
      // console.log('⛔️ element does NOT have child with id');
    }
    document
      .querySelector('.m-nested-tab')
      .classList.remove('has-image-l-text-r');
    if (selItem.querySelector('.image-l-text-r') !== null) {
      selItem.closest('.m-nested-tab').classList.add('has-image-l-text-r');
      // console.log('✅ element has child with id of child-3');
    } else {
      // console.log('⛔️ element does NOT have child with id');
    }
    document.querySelectorAll('.m-nested-tab').forEach(function (selItem) {
      // Remove the 'has-active-tab' class initially
      selItem.classList.remove('has-active-tab');

      // Check if any child of selItem has the 'active' class
      if (selItem.querySelector('.active') !== null) {
        selItem.classList.add('has-active-tab');
        document.querySelector('.moreInfoText').classList.add('d-none');
        document.querySelector('.moreInfoBut').classList.remove('d-none');
        // console.log('✅ element has child with class "active"');
      } else {
        // console.log('⛔️ element does NOT have child with class "active"');
      }
    });
  }

  reportFilter() {
    // var selectfirst=document.querySelector('.select-items div');
    // selectfirst.classList.add('same-as-selected');
    // document.querySelector('.select-selected').innerHTML=selectfirst.textContent;
    var tabpane = document.querySelector('.tab-pane');
    tabpane.classList.add('show', 'active');
    const listBtn = document.querySelector('#listMenu');
    listBtn.addEventListener('click', function (e) {
      e.preventDefault();

      document.querySelector('.moreInfoBut').classList.add('d-none');
      document.querySelector('.moreInfoText').classList.remove('d-none');

      //$('.m-nested-tab .pill-filter--sp .select-selected').trigger('click');
      const seledItem = document.querySelector(
        '.pill-filter--sp .select-selected',
      );
      seledItem.classList.add('d-none');
      const selItem = document.querySelector('.pill-filter--sp .select-items');
      setTimeout(function () {
        selItem.classList.remove('select-items--is-hide');
      }, 100);
      return false;
    });

    var hash = window.location.hash.substring(1);
    if (hash != undefined && hash != '') {
      var ele = document.getElementById('m-nested-tab');
      window.scrollTo(ele.offsetLeft, ele.offsetTop);
      document
        .querySelectorAll('[data-anchor=' + hash + ']')
        .forEach((elem) => {
          elem.click();
          var navItem = elem.getAttribute('aria-controls');
          var elem_mobile = document.querySelector(
            '[data-partners=' + navItem + ']',
          );
          elem_mobile.click();
          document
            .querySelector('.select-selected')
            .classList.remove('select-selected--is-active');
          document
            .querySelector('.select-items')
            .classList.add('select-items--is-hide');
          document.querySelector('.select-selected').innerHTML =
            elem_mobile.textContent;
          var selItem = document.getElementById(navItem);
          this.addClassifactive(selItem);

          return false;
        });
    } else {
      const selItem = document.querySelector('.pill-filter--sp .select-items');
      setTimeout(function () {
        selItem.classList.remove('select-items--is-hide');
      }, 100);
      // $('.m-nested-tab .pill-filter--sp .select-selected').trigger('click');
    }

    $(document).on('click', '.pill-filter--sp .select-items div', (e) => {
      // console.log('clicked');
      e.preventDefault();
      var elem = $(e.currentTarget),
        navItem = elem.attr('data-partners'),
        tabpane = document.querySelectorAll('.tab-pane'),
        selItem = document.querySelector(navItem);
      if (selItem == null) {
        selItem = document.getElementById(navItem);
      }
      if (elem.attr('data-url') !== 'null') {
        window.location.href = elem.attr('data-url');
        return false;
      }
      tabpane.forEach(function (item) {
        item.classList.remove('show', 'active', 'm-two-column-bullet-text');
      });
      this.addClassifactive(selItem);

      selItem.classList.add('show', 'active');
    });

    $(document).on('click', '.nav-pills>li.nav-item>button', (e) => {
      var elem = $(e.currentTarget),
        navItem = elem.attr('aria-controls'),
        selItem = document.getElementById(navItem),
        url = elem.attr('data-url');
      if (url !== undefined) {
        // document.getElementById("nav-tabContent").innerHTML="<div class='tab-pane show active'><section class='bullettext-l-image-r blob-4 bullettext-l-image-r bg-dark-green pt-8 pt-md-0 position-relative text-white'><div class='container'><div class='row'><div class='image-l-text-r__text pe-xl-1 offset-md-5 col-md-7'></div></div></div></section></div>";
        window.location.href = url;
        return false;
      }

      document
        .querySelector('.m-nested-tab')
        .classList.remove('has-m-two-column-bullet-text');
      this.addClassifactive(selItem);
    });
  }

  sliderInit() {
    Swiper.use([Navigation, Pagination, Autoplay]);
    let ss = document.querySelectorAll('.swipid');
    var swiper = [];
    ss.forEach(function (item) {
      var sid = item.value;
      var isSlider = true;
      var isloop = false;
      var slidon = document.querySelector('.slider-' + sid);
      var slidNav = document.querySelector('.slider-' + sid + '-control');

      if (item.classList.contains('noSlider') && $(window).width() > 767) {
        isSlider = false;
        //slidNav.parentElement.style.display='none';
        slidNav.parentNode.classList.remove('d-md-block');
      }
      //console.log(isSlider + "here"+$(window).width());
      if (isSlider) {
        if (slidon.getAttribute('data-slide') == 'on') isloop = true;
        swiper[sid] = new Swiper('.slider-' + sid, {
          slidesPerView: 1,
          spaceBetween: 36,
          grabCursor: true,
          loop: isloop,
          speed: 500,
          allowTouchMove: false,
          pagination: {
            el: '.slider-' + sid + '-control .slider__pagination',
            clickable: true,
          },
          navigation: {
            nextEl: '.slider-' + sid + '-control .slider__button-next',
            prevEl: '.slider-' + sid + '-control .slider__button-prev',
          },
          breakpoints: {
            768: {
              spaceBetween: 16,
              slidesPerView: 3,
            },
          },
        });
      }
    });
  }

  resizeEvents() {
    $(window).on('resize', () => {
      // this.sliderInit();
      // if ($(window).width() >= 768) {
      //   var tabpane = document.querySelector(".tab-pane");
      //   tabpane.classList.add('show','active');
      // }else{
      //   var tabpane = document.querySelector(".tab-pane");
      //   tabpane.classList.remove('show','active');
      // }
    });
  }

  events() {
    this.resizeEvents();
    this.onLoad();
  }

  onLoad() {
    const element = document.querySelector(
      '.stay-in-loop-with-svg #form-shortcode-wrap .primaryAction',
    );
    if (element) {
      // The selector exists on the page
      element.value = 'Continue sign up in the next step';
    }
    // document.querySelector('.stay-in-loop-with-svg #form-shortcode-wrap .primaryAction').value="Continue sign up in next step";
  }

  clickEvents() {}

  customSelect() {
    var x, i, j, l, ll, selElmnt, a, b, c;
    /*look for any elements with the class "custom-select":*/
    x = document.getElementsByClassName('ft-custom-select');
    l = x.length;

    for (i = 0; i < l; i++) {
      selElmnt = x[i].getElementsByTagName('select')[0];
      ll = selElmnt.length;
      /*for each element, create a new DIV that will act as the selected item:*/
      a = document.createElement('DIV');
      a.setAttribute(
        'class',
        'select-selected d-none select-selected--is-active',
      );
      a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
      x[i].appendChild(a);
      /*for each element, create a new DIV that will contain the option list:*/
      b = document.createElement('DIV');
      b.setAttribute('class', 'select-items select-items--is-hide');
      b.setAttribute('id', 'myItems');
      for (j = 0; j < ll; j++) {
        /*for each option in the original select element,
                create a new DIV that will act as an option item:*/
        c = document.createElement('DIV');
        c.innerHTML = selElmnt.options[j].innerHTML;
        c.setAttribute(
          'data-partners',
          selElmnt.options[j].getAttribute('value'),
        );
        c.setAttribute(
          'data-url',
          selElmnt.options[j].getAttribute('data-url'),
        );
        c.addEventListener('click', function (e) {
          /*when an item is clicked, update the original select box,
                    and the selected item:*/
          document.querySelector('.select-selected').classList.remove('d-none');
          var y, i, k, s, h, sl, yl, currentText;
          s = this.parentNode.parentNode.getElementsByTagName('select')[0];
          sl = s.length;
          h = this.parentNode.previousSibling;
          for (i = 0; i < sl; i++) {
            if (s.options[i].innerHTML == this.innerHTML) {
              s.selectedIndex = i;
              currentText = this.innerHTML;
              currentText =
                'Clear Filter' == currentText ? 'Filter' : currentText;
              h.innerHTML = currentText;
              y = this.parentNode.getElementsByClassName('same-as-selected');
              yl = y.length;
              for (k = 0; k < yl; k++) {
                y[k].removeAttribute('class');
              }
              this.setAttribute('class', 'same-as-selected');
              break;
            }
          }
          h.click();
        });
        b.appendChild(c);
      }
      x[i].appendChild(b);
      a.addEventListener('click', function (e) {
        /*when the select box is clicked, close any other select boxes,
                and open/close the current select box:*/
        // console.log("in here");
        // // return false;
        // e.stopPropagation();
        // closeAllSelect(this);
        // // // document.querySelector('.select-items').classList.toggle('select-items--is-hide');
        // // // document.querySelector('.select-selected').classList.toggle('select-selected--is-active');
        // this.nextSibling.classList.toggle('select-items--is-hide');
        // this.classList.toggle('select-selected--is-active');
      });
    }
    function closeAllSelect(elmnt) {
      /*a function that will close all select boxes in the document,
            except the current select box:*/
      var x,
        y,
        i,
        xl,
        yl,
        arrNo = [];
      x = document.getElementsByClassName('select-items');
      y = document.getElementsByClassName('select-selected');
      xl = x.length;
      yl = y.length;
      for (i = 0; i < yl; i++) {
        if (elmnt == y[i]) {
          arrNo.push(i);
        } else {
          y[i].classList.remove('select-selected--is-active');
        }
      }
      for (i = 0; i < xl; i++) {
        if (arrNo.indexOf(i)) {
          x[i].classList.add('select-items--is-hide');
        }
      }
      //y[0].classList.toggle('select-selected--is-active');
    }
    /*if the user clicks anywhere outside the select box,then close all select boxes:*/
    document.addEventListener('click', closeAllSelect);
  }
}

export default sliderSwiperStories;
new sliderSwiperStories();
